import { render, staticRenderFns } from "./UploadImageWidget.vue?vue&type=template&id=31031912&scoped=true&"
import script from "./UploadImageWidget.vue?vue&type=script&lang=js&"
export * from "./UploadImageWidget.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageWidget.vue?vue&type=style&index=0&id=31031912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31031912",
  null
  
)

export default component.exports